import http from '../utils/http';
import i18n from '@/main';

const baseUrl = '/territorios';

export default {
    findAll(params) {
        return http.get({
            url:
                baseUrl +
                `/buscaTerritorioPaginado?page=${params.page}&size=${params.size}${params.order}&searchText=${params.search}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },
    findAllAgricolaFilter(params, filtros) {
        return http.post({
            url:
                baseUrl +
                `/buscaTerritorioPaginadoFiltroAgricola?page=${params.pagina}&size=${params.tamanho}&sort=${params.ordenacao}`,
            lockScreen: false,
            data: JSON.parse(JSON.stringify(filtros)),
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    findByMapaHome() {
        return http.get({
            url: baseUrl + '/mapa-home',
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    findByMapaMonitoramentoSocio(filtros) {
        return http.post({
            url: baseUrl + '/mapa-socio-ambiental',
            data: filtros,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    findByMapaAgricola(filtros) {
        return http.post({
            url: baseUrl + '/mapa-agricola',
            data: filtros,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    findGeometriaByIdTerritorio(idTerritorio) {
        return http.get({
            url: baseUrl + `/geometria-territorio/${idTerritorio}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoGeometriaDoTerritorio')
        });
    },

    findGeometriaByIdLocalidade(idLocalidade) {
        return http.get({
            url: baseUrl + `/geometria-localidade/${idLocalidade}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoGeometriaDoMunicipio')
        });
    },

    findById(territorioId) {
        return http.get({
            url: baseUrl + `/${territorioId}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    findAllPaginadoSocioAmbiental(params) {
        return http.post({
            url:
                baseUrl +
                `/socioambiental/buscaTerritorioPaginado?page=${params.page}&size=${params.size}${params.order}`,
            data: { ...params.filtro },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    add(territorio) {
        return http.post({
            url: baseUrl,
            data: { ...territorio },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.salvandoTerritorio')
        });
    },

    validarSobreposicaoTerritorio(geometria, id) {
        return http.post({
            url: baseUrl + '/validar-sobreposicao-territorio',
            data: { geoJson: geometria, idTerritorio: id },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.validandoSobreposicaoDeTerritoriosCadastrados')
        });
    },

    delete(territorioId) {
        return http.delete({
            url: baseUrl,
            data: { territorioId },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.removendoTerritorio')
        });
    },

    update(territorio) {
        return http.put({
            url: baseUrl + `/${territorio.id}`,
            data: { ...territorio },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.salvandoTerritorioAtualizado')
        });
    },

    findByCar(car) {
        return http.get({
            url: baseUrl + `/car/${car}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },

    verificarRepresentante(idRepresentante) {
        return http.get({
            url: baseUrl + `/verificar?idRepresentante=${idRepresentante}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.verificandoSeORepresentantePossuiTerritorio')
        });
    },

    consolidaTerritorio(listaTerritorio) {
        return http.post({
            url: baseUrl + `/consolidar-territorio`,
            data: listaTerritorio,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.consolidandoTerritorio')
        });
    },

    diagnosticoSocioambiental(idTerritorio, salvar = true, protocolo = 'PROTOCOLO_VEGA') {
        let path = baseUrl + `/socioambiental/por-territorio/${idTerritorio}?salvar=${salvar}`;
        if (protocolo) {
            path = path.concat(`&protocolo=${protocolo}`);
        }

        return http.get({
            url: path,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.realizandoDiagnostico')
        });
    },

    findAllSimplificado(filtro = '') {
        return http.get({
            url: baseUrl + `/simplificado?filtro=${filtro}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    findAllSimplificadoPaginado(params, filtro = '') {
        return http.get({
            url: baseUrl + `/simplificado-paginado?page=${params.page}&size=${params.size}&filtro=${filtro}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    findSimplificadoPorCar(car) {
        return http.get({
            url: baseUrl + `/simplificado/car/${car}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    findSimplificadoPorCarPaginado(params, car) {
        return http.get({
            url: baseUrl + `/simplificado-paginado/car/${car}?page=${params.page}&size=${params.size}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    solicitacaoLaudo(listaTerritorios) {
        return http.post({
            url: baseUrl + `/solicitacao`,
            data: listaTerritorios,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.solicitandoTerritorios')
        });
    },

    findCarsByTerritorio(territorio) {
        return http.post({
            url: baseUrl + `/cars/por-territorio/`,
            data: { ...territorio },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.verificandoSobreposicaoDeCars')
        });
    },

    findProdutos() {
        return http.get({
            url: baseUrl + `/produtos`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoProdutos')
        });
    },

    findUnidadesMedida() {
        return http.get({
            url: baseUrl + `/unidade-medidas`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoUnidadesDeMedida')
        });
    },

    updateComercializacoes(territorio) {
        return http.put({
            url: baseUrl + `/comercializacoes/${territorio.id}`,
            data: territorio.comercializacoes,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.atualizandoComercializacoes')
        });
    },

    getStatusMonitoramento(idTerritorio) {
        return http.get({
            url: baseUrl + `/${idTerritorio}/status-monitoramento`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.verificandoSeOTerritorioEstaEmMonitoramento')
        });
    },

    buscarTipoCertificacao() {
        return http.get({
            url: baseUrl + `/tipo-certificacao`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTipoDeCertificacao')
        });
    },

    realizarPesquisaInteligente(filtro) {
        return http.get({
            url: baseUrl + `/pesquisa-inteligente?filtro=${filtro}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.realizandoPesquisa')
        });
    },

    buscarTerritoriosPorIdRepresentante(idRepresentante) {
        return http.get({
            url: baseUrl + `/representante/${idRepresentante}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritoriosDoRepresentante')
        });
    },

    filtrarCadastroGleba(filtro) {
        return http.get({
            url: baseUrl + `/filtrar/cadastro/gleba?filtro=${filtro}`,
            lockScreen: false
        });
    },

    buscarCadastroGleba(idTerritorio) {
        return http.get({
            url: baseUrl + `/${idTerritorio}/buscar/cadastro/gleba`,
            lockScreen: false
        });
    },
    buscarSituacaoCamadaCategoria(idTerritorio) {
        return http.get({
            url: baseUrl + `/socio-ambiental/situacao/${idTerritorio}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoSituacaoDoTerritorio')
        });
    },
    findGeometryByCAR(car) {
        return http.get({
            url: baseUrl + `/geometria/${car}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoGeometria')
        });
    },
    calcularAreaGeometria(geometria) {
        return http.post({
            url: baseUrl + '/calcular-area-geometria',
            data: { geoJson: geometria },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.calculandoGeometria')
        });
    },
    validarSobreposicaoTerritorioParaguai(geometria, id) {
        return http.post({
            url: baseUrl + '/validar-sobreposicao-territorio-paraguai',
            data: { geoJson: geometria, idTerritorio: id },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.validandoSobreposicaoDeTerritoriosCadastrados')
        });
    }
};
